export interface CalculateJobETARequest {
    JobIds: string[],
    ConnectionId: string,
  }